<template>
    <crud-facecade
        ref="databasebackup-list"
        :url="url"
        :columns="columnList"
        :buttons="buttons"
        v-wechat-title="title"
        :addButton="{ enabled: false, permission: 'default' }"
        :updateButton="{ enabled: false, permission: 'default' }"
    >
        <template slot="filter">
            <el-col :md="8" :xl="5">
                <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
            </el-col>
        </template>
        <template slot="filter-after">
            <el-button type="primary" size="mini" @click="backupdatabase">备份</el-button>
        </template>
    </crud-facecade>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `DatabaseBackup`,
    props: {

    },
    data() {
        return {
            title: `备份管理`,
            messageList: [],
            url: { baseURL: `/api/AcisSystem/DatabaseBackup/`,
                get: () => {
                    return this.ReloadListData()
                } },
            buttons: [],
            rdate: [this.$moment().add(-2, `days`).format(`YYYY/MM/DD`), this.$moment().add(1, `days`).format(`YYYY/MM/DD HH:mm:ss`)],
            users: []
        }
    },
    created() {
        // this.loadUsers()
    },
    computed: {
        ...mapGetters([`sys_enums`]),
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: true
            }, {
                type: `datetime`,
                prop: `backup_start_date`,
                label: `备份开始日期`,
                isListable: true,
                width: `180`,
                sortable: true,
                isExpand: false
            }, {
                type: `datetime`,
                prop: `backup_finish_date`,
                label: `备份结束日期`,
                isListable: true,
                width: `180`,
                isExpand: false
            }, {
                type: `string`,
                prop: `database_name`,
                label: `数据库名称`,
                isListable: true,
                width: `180`,
                isExpand: false
            }, {
                type: `string`,
                prop: `back_up_type`,
                label: `备份类型`,
                isListable: true,
                width: `80`,
                isExpand: false
            }, {
                type: `string`,
                prop: `latest_backup_location`,
                label: `备份地址`,
                isListable: true,
                width: `180`,
                isExpand: false
            }, {
                type: `string`,
                prop: `backup_size_mb`,
                label: `备份前文件大小`,
                isListable: true,
                width: `120`,
                isExpand: false
            }, {
                type: `string`,
                prop: `compressed_backup_size_mb`,
                label: `备份后文件大小`,
                isListable: true,
                width: `120`,
                isExpand: false
            }, {
                type: `string`,
                prop: `exec_pepole_name`,
                label: `执行人`,
                isListable: true,
                width: `180`,
                isExpand: false
            }
            ]
        }
    },
    mounted() {

    },
    methods: {
        ReloadListData() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/DatabaseBackup/GetInfo`, { begin: this.rdate[0], end: this.rdate[1] })
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        backupdatabase() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/DatabaseBackup/BackUpDataBase`)
                req.then(data => {
                    this.$refs[`databasebackup-list`].ReloadListData()
                    resolve(data)
                })
            })
        }
    },
    watch: {
        rdate: function() {
            this.$refs[`databasebackup-list`].ReloadListData()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DatabaseBackup/Index.vue